import { useEffect, useRef } from 'react'

export const useKeyupHandler = (
  handler: (event: KeyboardEvent) => void,
  listenIf = true,
) => {
  const keyupHandlerRef = useRef<((event: KeyboardEvent) => void) | null>(null)

  useEffect(() => {
    const cleanUp = () => {
      if (keyupHandlerRef.current) {
        document.removeEventListener('keyup', keyupHandlerRef.current)
      }
    }

    if (listenIf) {
      cleanUp()

      keyupHandlerRef.current = handler
      document.addEventListener('keyup', keyupHandlerRef.current)
    }

    return cleanUp
  }, [handler, listenIf])
}
